import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CollapseIconButton from 'components/fulcrum/collapse/CollapseIconButton'
import ModifyIconButton from './ModifyIconButton'
import { Flex } from 'reflexbox'

const Actions = ({id, onSave, edit, toggleEdit, toggleCollapse, collapse, fetchAeRegionSelection}) => {
  return (
    <Flex justify='flex-end'>
      <ModifyIconButton
        toggleEdit={() => {
          if (!edit) fetchAeRegionSelection()
          toggleEdit()
        }}        
        edit={edit}
        onSave={onSave}
        id={id}
      />
      <CollapseIconButton
        toggleCollapse={toggleCollapse}
        collapse={collapse}
      />
    </Flex>
  )
}

export default Actions
